export default {
  sm: `
  Various services we use every day run 24 hours a day and 365 days a year in data centers, and newly created data is also stored and managed securely. Once stored, the data is delivered from the data center to users over the internet network, anytime, anywhere. This happens in less than a second.
  `
};
